import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { colors, breakpoints } from 'app/variables';
import { CheckIcon } from 'app/commonComponents/icons';

const Step = styled.div`
  align-items: center;
  background-color: ${(props) =>
    props.$active || props.$completed ? colors.pacificBlue : colors.silver};
  border-radius: 50%;
  color: ${colors.white};
  cursor: ${(props) => (props.$completed ? 'pointer' : 'inherit')};
  display: flex;
  height: 4rem;
  justify-content: center;
  transform: translate(0, -50%);
  width: 4rem;
`;

const Container = styled.div`
  background-color: ${colors.silver};
  display: flex;
  height: 1px;
  justify-content: space-between;
  margin: 2rem 0 7rem;

  @media (min-width: ${breakpoints.medium}) {
    margin-left: -2rem;
    margin-right: -2rem;
  }

  ${(props) =>
    props.$done &&
    css`
      & ${Step} {
        background-color: ${colors.java};

        &:last-of-type {
          height: 8rem;
          width: 8rem;

          svg {
            height: 2.75rem !important;
            width: 2.75rem !important;
          }
        }
      }
    `}
`;

function StepIndicator({ step, numSteps, onStep }) {
  const done = step === numSteps;
  return (
    <Container $done={done}>
      {new Array(numSteps).fill().map((_, i) => {
        const s = i + 1;
        const active = s === step;
        const completed = s < step;
        const additionalProps = !done &&
          completed && {
            role: 'button',
            'aria-label': `go to step ${s}`,
            onClick: () => onStep(s, step),
          };
        return (
          <Step
            key={i}
            $active={active}
            $completed={completed}
            {...additionalProps}
          >
            {s === numSteps ? (
              <CheckIcon xsmall style={{ strokeWidth: 2.5 }} />
            ) : (
              s
            )}
          </Step>
        );
      })}
    </Container>
  );
}

StepIndicator.propTypes = {
  step: PropTypes.number,
  numSteps: PropTypes.number,
  onStep: PropTypes.func,
};

export default StepIndicator;
